/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, matchPath } from 'react-router-dom';
import UserDropdown from 'containers/UserDropdown';
import Notifications from './Notifications';
import { logout } from 'actions/User';
import { showModal } from 'actions';
import { CREATE_TEAM, RESEND_VERIFIY_EMAIL } from 'constants/ModalTypes';
import { requiresEmailVerification } from 'utils/userHelper';

import styled from 'styled-components';
import Paths from 'AppPaths';

const MainHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px 48px;
  background: #fff;
  box-shadow: 0 2px 8px #c8ccd5;
  max-height: 64px;
  box-sizing: border-box;

  position: sticky;
  top: 0;
  z-index: 5;

  @media only screen and (max-width: 578px) {
    padding: 20px 20px;
  }
`;

const Nav = styled.ul`
  display: flex;
  align-items: center;
  margin: 0;
  margin-left: auto;
  list-style: none;
  padding: 0;

  li {
    margin-left: auto;
  }
`;

const UserDropdownWrapper = styled.div`
  margin-left: 20px;

  a {
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      svg {
        margin-left: 4px;
      }
    }
  }

  @media only screen and (max-width: 578px) {
    div[id*='user_avatar'] {
      display: none !important;
    }
  }

  @media only screen and (max-width: 360px) {
    margin-left: 5px;

    a {
      width: 170px;
      padding: 0;
      text-align: center;

      span {
        font-size: 13px;
        width: 100%;
      }
    }
  }
`;

const HeaderPropTypes = {
  team: PropTypes.object,
  logout: PropTypes.func,
  showModal: PropTypes.func,
  user: PropTypes.object,
  isTeamExisting: PropTypes.bool
};

const Header = ({ user, team, logout, showModal, isTeamExisting }) => {
  const isUserDashboard = matchPath(window.location.pathname, {
    path: Paths.UserDash,
    strict: false
  })?.isExact;

  const requiresVerification = useMemo(
    () => requiresEmailVerification(user),
    [user]
  );

  const topNavNotificationProps = {
    team,
    user,
    isUserDashboard: isUserDashboard,
    isTeamExisting
  };

  if (isUserDashboard && !isTeamExisting) {
    topNavNotificationProps.onClick = showModal.bind(null, CREATE_TEAM);
  }

  if (requiresVerification) {
    topNavNotificationProps.onClick = showModal.bind(
      null,
      RESEND_VERIFIY_EMAIL
    );
  }

  return (
    <>
      <MainHeader>
        <Notifications />

        <Nav>
          <UserDropdownWrapper>
            <UserDropdown user={user} onLogoutClick={logout} />
          </UserDropdownWrapper>
        </Nav>
      </MainHeader>
    </>
  );
};

Header.propTypes = HeaderPropTypes;

export default compose(
  withRouter,
  connect(
    ({ user, team, teams }) => {
      const isTeamExisting = teams?.length > 0;
      return { user, team, isTeamExisting };
    },
    { logout, showModal }
  )
)(Header);
